import React from 'react';
import { Router, Route } from 'react-router';

import { DashboardProfileV2, DashboardProfile } from '../containers';
import * as routes from './const';

const dashboardProfileRoutes = (
  <Router>
    <Route path={routes.DASHBOARD_PROFILE} component={DashboardProfile} />
    <Route path={routes.DASHBOARD_PROFILE_ID} component={DashboardProfileV2} />
  </Router>
);

export default dashboardProfileRoutes;



// WEBPACK FOOTER //
// ./src/features/dashboard/routes/index.js